export * from './lib/geo-coords-data-access.module';
export { GeoCoordsService } from './lib/geo-coords.service';
